import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBox2AltFill: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBox2AltFill"><Path fillRule="evenodd" clipRule="evenodd" d="M21 3V21H3L3.00006 3.00001L21 3ZM4.50003 13L4.50005 4.50001L19.5 4.5V13L15.25 13C15.25 13.2092 15.2303 13.4131 15.1929 13.6102C14.9078 15.1135 13.5858 16.25 12 16.25C10.4142 16.25 9.09221 15.1135 8.80706 13.6102C8.76967 13.4131 8.75 13.2092 8.75 13L4.50003 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBox2AltFill;
